import React, { useEffect, useState, lazy, Suspense } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

import Navbardesign from "../Components/Navbar";
import BannerSwiper from "../Components/Bannerdesign/Bannerdesign";
import ProjectSection from "../Components/Projectcard/Projectdesign";
import Footer from "../Components/FooterDomain/Footerdata";
import ContactBar from "../Components/Fixedpossion/Fixedposion";

/* ---------------- LAZY LOAD ---------------- */
const Testimonials = lazy(() =>
  import("../Components/Testimonalprocess/Testimonalsprocess")
);

/* ---------------- API BASE ---------------- */
const API_BASE = "https://mithahomesfrontend.pemixcels.com/api";
const VIEW_API = `${API_BASE}/apiviewcount`;
const POPUP_API = `${API_BASE}/popmodelimage/popup-image`;
const IMAGE_BASE_URL = "https://mithahomesfrontend.pemixcels.com";

/* ---------------- COMPONENT ---------------- */
const MyComponent = () => {
  const [showModal, setShowModal] = useState(false);
  const [popupImage, setPopupImage] = useState(null);
  const [projectId, setProjectId] = useState(null);

  const navigate = useNavigate();

  /* ===============================
     SCROLL FIX
  ================================ */
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, []);

  /* ===============================
     VIEW COUNT + ACTIVE USER
  ================================ */
  useEffect(() => {
    const trackActiveUser = async () => {
      try {
        await axios.post(`${VIEW_API}/active`);
      } catch {
        console.error("Active user tracking failed");
      }
    };

    const increaseViewCount = async () => {
      try {
        await axios.post(`${VIEW_API}/view`);
      } catch {
        console.error("View count update failed");
      }
    };

    trackActiveUser();
    increaseViewCount();
  }, []);

  /* ===============================
     FETCH POPUP IMAGE
  ================================ */
  useEffect(() => {
    const fetchPopupImage = async () => {
      try {
        const res = await axios.get(POPUP_API);

        if (res.data.success && res.data.data.length > 0) {
          const activeImage = res.data.data.find(
            (item) => item.is_active === true
          );

          if (activeImage) {
            setPopupImage(`${IMAGE_BASE_URL}${activeImage.image}`);
            setProjectId(activeImage.project_id);
            setShowModal(true);
          }
        }
      } catch (error) {
        console.error("Popup image fetch failed");
      }
    };

    fetchPopupImage();
  }, []);

  /* ---------------- IMAGE CLICK ---------------- */
  const handleImageClick = () => {
    setShowModal(false);
    if (projectId) {
      navigate(`/project/${projectId}`);
    }
  };

  return (
    <>
      {/* ================= POPUP MODAL ================= */}
      {showModal && popupImage && (
        <div style={styles.overlay}>
          <div style={styles.modal}>
            <button
              aria-label="Close popup"
              onClick={() => setShowModal(false)}
              style={styles.closeBtn}
            >
              ×
            </button>

            <img
              src={popupImage}
              alt="Project Promotion"
              width="600"
              height="400"
              loading="eager"
              decoding="async"
              fetchpriority="high"
              style={styles.modalImage}
              onClick={handleImageClick}
            />
          </div>
        </div>
      )}

      {/* ================= PAGE CONTENT ================= */}
      <Navbardesign />

      <br />
      <br />
      <br />

      <BannerSwiper />
      <ProjectSection />

      {/* ---------- LAZY TESTIMONIALS ---------- */}
      <Suspense fallback={<div style={{ minHeight: "280px" }} />}>
        <Testimonials />
      </Suspense>

      <Footer />

      {/* ---------- CONTACT BAR GAP ---------- */}
      <div style={{ height: "90px" }} />
      <ContactBar />
    </>
  );
};

/* ================= INLINE STYLES ================= */
const styles = {
  overlay: {
    position: "fixed",
    inset: 0,
    backgroundColor: "rgba(0,0,0,0.55)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "16px",
    zIndex: 10000,
  },

  modal: {
    position: "relative",
    width: "600px",
    maxWidth: "100%",
    backgroundColor: "#f5ede4",
    borderRadius: "16px",
    boxShadow: "0 20px 50px rgba(0,0,0,0.4)",
    overflow: "hidden",
  },

  modalImage: {
    width: "100%",
    height: "auto",
    display: "block",
    cursor: "pointer",
    objectFit: "cover",
  },

  closeBtn: {
    position: "absolute",
    top: "10px",
    right: "10px",
    width: "36px",
    height: "36px",
    borderRadius: "50%",
    border: "none",
    background: "#ffffff",
    fontSize: "22px",
    fontWeight: "bold",
    cursor: "pointer",
    boxShadow: "0 2px 10px rgba(0,0,0,0.25)",
    lineHeight: "32px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
};

export default MyComponent;
